import { render, staticRenderFns } from "./PayrollFinalizationGrid.vue?vue&type=template&id=1afe1dca"
import script from "./PayrollFinalizationGrid.vue?vue&type=script&lang=js"
export * from "./PayrollFinalizationGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports